// extracted by mini-css-extract-plugin
export default {"title":"index_title__O5TzH","menu":"index_menu__9HE8I","divider":"index_divider__1cINS"};